import Vue from "vue";
import Router from "vue-router";
// import Home from "@/pages/home";
// import Course from "@/pages/course";
// import AbilityTest from "@/pages/abilityTest";
// import Teachers from "@/pages/teachers";
// import League from "@/pages/league";
// import Promotion from "@/pages/promotion";
import NewPromotion from "@/pages/newPromotion";
import Success from "@/pages/success";
import Underfind from "@/pages/underfind";
Vue.use(Router);

export default new Router({
  mode: "hash",
  routes: [
    // {
    //   path: "/",
    //   name: "Promotion",
    //   component: Promotion
    // },
    {
      path: "/",
      name: "NewPromotion",
      meta: {
        title: "哈兔中文免费试读体验课-好课程，好老师，好效果！"
      },
      component: NewPromotion
    },
    {
      path: "/success",
      name: "Success",
      meta: {
        title: "信息填写成功"
      },
      component: Success
    },

    // 新的学中文落地页
    {
      path: "/newStudyChineseOne",
      name: "newStudyChineseOne",
      meta: {
        title: "学中文"
      },
      component: () => import("@/pages/newStudyChineseOne")
    },
    {
      path: "/newStudyChineseTwo",
      name: "newStudyChineseTwo",
      meta: {
        title: "学中文"
      },
      component: () => import("@/pages/newStudyChineseTwo")
    },
    {
      path: "/newStudyChineseThree",
      name: "newStudyChineseThree",
      meta: {
        title: "学中文"
      },
      component: () => import("@/pages/newStudyChineseThree")
    },

    // aoe落地页 来华留学1
    {
      path: "/studyInChinaOne",
      name: "studyInChinaOne",
      meta: {
        title:
          "AoeChinese Study-in-China Program: Fast-track scholarship Application"
      },
      component: () => import("@/pages/studyInChinaOne")
    },
    // aoe落地页 来华留学2
    {
      path: "/studyInChinaTwo",
      name: "studyInChinaTwo",
      meta: {
        title:
          "AoeChinese Study-in-China Program: Fast-track scholarship Application"
      },
      component: () => import("@/pages/studyInChinaTwo")
    },
    // aoe落地页hsk1
    {
      path: "/hsk1",
      name: "hsk1",
      meta: {
        title: "AoeChinese HSK courses: Pass your HSK exams easily"
      },
      component: () => import("@/pages/hsk1")
    },
    // aoe落地页hsk2
    {
      path: "/hsk2",
      name: "hsk2",
      meta: {
        title: "AoeChinese HSK courses: Pass your HSK exams easily"
      },
      component: () => import("@/pages/hsk2")
    },
    // 学中文落地页1
    {
      path: "/studyChineseOne",
      name: "studyChineseOne",
      meta: {
        title:
          "AoeChinese Chinese courses: Easy, fun, and interactive learning approach"
      },
      component: () => import("@/pages/studyChineseOne")
    },
    // 学中文落地页2
    {
      path: "/studyChineseTwo",
      name: "studyChineseTwo",
      meta: {
        title:
          "AoeChinese Chinese courses: Easy, fun, and interactive learning approach"
      },
      component: () => import("@/pages/studyChineseTwo")
    },
    { path: "*", component: Underfind }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js